import ga from '../utils/ga'

interface IClickOptions {
  eventLabel: string
  eventValue?: number
  dimension19?: string
  eventAction?: string
}

export const reportBlockClick = (
  blockName: string,
  blockClickOptions: IClickOptions
) => {
  ga('send', {
    hitType: 'event',
    eventCategory: `Block interaction;${blockName}`,
    eventAction: 'click;button',
    ...blockClickOptions
  })
}
